import { render, staticRenderFns } from "./ProductSizeBarcodeFilter.vue?vue&type=template&id=550af51a"
import script from "./ProductSizeBarcodeFilter.vue?vue&type=script&lang=ts"
export * from "./ProductSizeBarcodeFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('550af51a')) {
      api.createRecord('550af51a', component.options)
    } else {
      api.reload('550af51a', component.options)
    }
    module.hot.accept("./ProductSizeBarcodeFilter.vue?vue&type=template&id=550af51a", function () {
      api.rerender('550af51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductSizeBarcodeFilter.vue"
export default component.exports